import type { SupportChatFeatureConfig } from './type';
import { SupportChatExternalAuthorizationMethod, SupportChatLanguage } from './type';

export const supportChat: Partial<SupportChatFeatureConfig> = {
    channelId: 'george-cz-va',
    externalAuthorizationMethod: SupportChatExternalAuthorizationMethod.OIDC,
    languagePackage: 'george-cz',
    supportedLanguages: [SupportChatLanguage.EN, SupportChatLanguage.CS],
    displayChatStatus: true,
    useAuthenticatedFlag: true,
    proactiveChatAutoHideInput: false,
    proactiveChatChannelId: 'heygeorge-cz-web',
};
